module.exports = __webpack_public_path__ + "media/images/icon__arrow-right@2x-373d22e00d5bf39d853b49a9a7e33c32.png";